import { getRootPluaralTranslator } from '@utils/get-module-translator'

const __rootTc = getRootPluaralTranslator()

export const downloadListColumns = () => {
  return [
    {
      name: `${__rootTc('reference_id')}`,
      key: 'trackingId',
    },
    {
      name: `${__rootTc('name')}`,
      key: 'name',
    },
    {
      name: __rootTc('module'),
      key: 'refModel',
    },
    {
      name: __rootTc('status'),
      key: 'downloadState',
    },
    { name: `${__rootTc('user')}`, key: 'createdById', width: '150px' },
    {
      name: __rootTc('event_start_date'),
      key: 'triggeredTime',
    },
    {
      name: __rootTc('event_end_date'),
      key: 'endTime',
    },
    {
      name: __rootTc('action', 2),
      key: 'action',
      width: '120px',
    },
  ]
}
